export default __webpack_public_path__ + "55081fabe7b305326977877badfb3c81.png";